import { Box } from "@mzc-pdc/ui";
import { Typography } from "@components_v2/typography/typography";
import theme from "@styles/theme";
import { ImageEmpty } from "@mzc-cloudplex/icons";
import { useTranslation } from "react-i18next";

export const NotifyEmpty = () => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                gap: 2.5,
                py: 5,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "80px",
                    height: "72px",
                }}
            >
                <ImageEmpty width={76} height={70} />
            </Box>
            <Typography
                variant="body1_400"
                sx={{
                    color: theme.palette.greySecondary.main,
                    textAlign: "center",
                }}
            >
                {t("common::msg::There are no notifications yet.", "There are no notifications yet.")}
            </Typography>
        </Box>
    );
};
